import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DialogActions, DialogContent } from '@mui/material';
import { increaseLimitsPlans } from '@shared/model/increaseLimits';
import { icons } from '@shared/static/icons';
import { formatBalanceUi, FRACTION_DIGITS } from '@utils/balance-helpers';
import { EmailBtn, TelegramBtn } from '@widgets/buttons';

function getActivePlan(commission) {
  if (commission === 0) return 'Tester';
  if (commission <= 1.8) return 'Private client';
  if (commission < 3.5) return 'Premium';
  return 'Starter';
}

export default function IncreaseLimitsDialog() {
  const tariff = useSelector((state) => state.tariff.tariff);
  const { t, i18n } = useTranslation();

  const activePlan = getActivePlan(tariff.top_up_commission);

  return (
    <>
      <DialogContent>
        <div className="increaseLimits__content">
          {increaseLimitsPlans.map((plan) => {
            const isCurrent = activePlan === plan.name;
            const values = isCurrent
              ? {
                  ...plan.values,
                  count_free_card: tariff.count_free_card,
                  daily_card_limit: tariff.daily_card_limit,
                  monthly_card_spent_limit: formatBalanceUi(
                    tariff.monthly_card_spent_limit,
                    null,
                    FRACTION_DIGITS.INTEGER,
                  ),
                  top_up_commission: tariff.top_up_commission,
                  withdraw_commission: tariff.withdraw_commission,
                }
              : plan.values;

            return (
              <div key={plan.name} className="increaseLimits__item">
                {isCurrent && (
                  <div className="increaseLimits__item-active">
                    {icons[`active-plan-${i18n.language}`]}
                  </div>
                )}

                <img
                  src={require(`@shared/assets/emoji/${plan.img}.svg`)}
                  alt={plan.name}
                  className="increaseLimits__item-img"
                />

                <div className="body-18m">{t(plan.name)}</div>

                <div className="increaseLimits__item-list">
                  <p>{t('requirements')}</p>
                  <ul>
                    {plan.requirements.map((key) => (
                      <li key={key}>
                        <Trans
                          i18nKey={key}
                          values={values}
                          components={{ span: <span /> }}
                        />
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="increaseLimits__item-list">
                  <p>{t('features')}</p>
                  <ul>
                    {plan.features.map((key) => {
                      // Для плана "Private client" если он не активный, заменяем cards_daily на cards_daily_unlimited
                      const featureKey =
                        plan.name === 'Private client' &&
                        !isCurrent &&
                        key === 'cards_daily'
                          ? 'cards_daily_unlimited'
                          : key;

                      return (
                        <li key={key}>
                          <Trans
                            i18nKey={featureKey}
                            values={values}
                            components={{ span: <span /> }}
                          />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="increaseLimits__actions">
          <p className="body-12r">{t('increase_limits_note')}</p>
          <div>
            <div className="btns-toolbar">
              <TelegramBtn />
              <EmailBtn />
            </div>
          </div>
        </div>
      </DialogActions>
    </>
  );
}
